"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refactorFilter = exports.getFilterValues = void 0;
const enums_1 = require("../enums");
function getFilterValues(filter) {
    // 先判断是否存在多值
    if (filter === null || filter === void 0 ? void 0 : filter.Values) {
        return filter.Values;
    }
    // 再判断是否存在最大最小值
    if ((filter === null || filter === void 0 ? void 0 : filter.Min) !== undefined || (filter === null || filter === void 0 ? void 0 : filter.Max) !== undefined) {
        return [filter.Min, filter.Max];
    }
    // 返回单值
    return [filter === null || filter === void 0 ? void 0 : filter.Value];
}
exports.getFilterValues = getFilterValues;
function refactorFilter(filter) {
    var _a, _b;
    // between类型单独处理
    const betweenOp = [
        enums_1.FilterOperatorEnum.DateBetween,
        enums_1.FilterOperatorEnum.DateNotBetween,
        enums_1.FilterOperatorEnum.NumberBetween,
        enums_1.FilterOperatorEnum.NumberNotBetween,
    ];
    if (betweenOp.includes(filter === null || filter === void 0 ? void 0 : filter.Operator)) {
        const { Values } = filter, others = __rest(filter, ["Values"]);
        return Object.assign(Object.assign({}, others), { Min: (_a = filter.Values) === null || _a === void 0 ? void 0 : _a[0], Max: (_b = filter.Values) === null || _b === void 0 ? void 0 : _b[1] });
    }
    return filter;
}
exports.refactorFilter = refactorFilter;
